import axios from 'axios';
import api from '../utils/functions/api';

const baseURL = process.env.REACT_APP_API_URL;

async function getPaymentListApi(
  roleMerchant,
  start,
  end,
  page,
  rowsPerPage,
  search,
  sortBy,
) {
  try {
    const resp = await api.get(
      `${baseURL}/invoice/paid?role=${roleMerchant}&startDate=${start}&endDate=${end}&page=${
        page + 1
      }&size=${rowsPerPage}&search=${search}&sortBy=${sortBy}`,
    );

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function getReceiptApi(order_id) {
  try {
    const resp = await api.get(`${baseURL}/pdf/receipt/${order_id}`)

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function getManualPaidApi(id) {
  try {
    const resp = await api.get(`${baseURL}/invoice/manual-paid/${id}`);

    return resp.data;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function paymentTransactionApi(payload) {
  try {
    const resp = await api.post(`${baseURL}/payment-transaction`, payload);

    return resp.data
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

async function postZipReceiptApi(orderIdList) {
  try {
    const resp = await api.post(`${baseURL}/pdf/receipt/download-zip`, { 
      orderIdList 
    }, {
      responseType: 'blob',
    }
  );

    return resp;
  } catch (error) {
    console.log(error);
    throw new Error(error.message);
  }
}

const PaymentListApi = {
  getPaymentListApi,
  getManualPaidApi,
  paymentTransactionApi,
  getReceiptApi,
  postZipReceiptApi
};
export default PaymentListApi;
